import React from "react";

const Profile = (props) => {
    return (
        <>Profile</>
    )
}

export default Profile;